export function isVideoMedia(src) {
  if (!src) return false;
  return /\/video\/upload\//.test(src) || /\.(mp4|webm|mov)(\?|$)/i.test(src);
}

function alreadyTransformed(src) {
  const i = src.indexOf("/upload/");
  if (i < 0) return true;
  const after = src.slice(i + 8);
  return /^(f_|q_|w_|c_|vc_|so_|e_)/.test(after) || after.includes(",");
}

export function cloudinaryUrl(src, { width = 960, poster = false } = {}) {
  if (!src || typeof src !== "string") return src;
  if (!src.includes("res.cloudinary.com") || !src.includes("/upload/")) return src;
  if (!poster && alreadyTransformed(src)) return src;

  if (poster) {
    const asJpg = src.replace(/\.(mp4|webm|mov)(\?.*)?$/i, ".jpg");
    return asJpg.replace("/upload/", `/upload/so_0,w_${width},q_auto,f_jpg/`);
  }

  if (isVideoMedia(src)) {
    return src.replace("/upload/", `/upload/q_auto:eco,vc_auto,w_${width}/`);
  }

  return src.replace("/upload/", `/upload/f_auto,q_auto,w_${width}/`);
}

export function videoPoster(src, width = 480) {
  if (!isVideoMedia(src)) return "";
  if (src.includes("res.cloudinary.com")) return cloudinaryUrl(src, { poster: true, width });
  return "";
}

export function glanceTileSrc(src, width = 400) {
  if (!src) return "";
  if (isVideoMedia(src)) return videoPoster(src, width) || src;
  return cloudinaryUrl(src, { width });
}

export function glanceFullSrc(src, width = 1400) {
  if (!src) return "";
  if (isVideoMedia(src)) return cloudinaryUrl(src, { width: 1280 });
  return cloudinaryUrl(src, { width });
}

export function preloadGlanceTiles(items, limit = 12) {
  if (typeof window === "undefined" || !items?.length) return;
  const seen = new Set();
  for (const item of items) {
    const src = item.tile || glanceTileSrc(item.src || item);
    if (!src || seen.has(src)) continue;
    seen.add(src);
    const img = new Image();
    img.decoding = "async";
    img.src = src;
    if (seen.size >= limit) break;
  }
}
